import * as React from "react"

export const NovaWordmark: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xlinkTitle="NOVA"
    width={props.width || "1200"}
    height={props.height || "303"}
    viewBox="0 0 1200 303"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-bg-7"
    {...props}>
    <title>NOVA</title>
    <path d="M0 0V302.488H64.4007V75.6219L139.535 151.244V64.8188L75.1342 0H0ZM214.669 226.866L139.535 151.244V237.669L203.936 302.488H279.07V0H214.669V226.866Z" />
    <path d="M521.646 0H371.377V64.8188H521.646V237.669L586.047 172.85V64.8188L521.646 0ZM371.377 237.669V64.8188L306.977 129.638V216.063L392.844 302.488H521.646V237.669H371.377Z" />
    <path d="M613.953 172.85L678.354 237.669V0H613.953V172.85ZM828.623 237.669L893.023 172.85V0H828.623V237.669ZM764.222 302.488L828.623 237.669H678.354L742.755 302.488H764.222Z" />
    <path d="M1092.67 0H1049.73L985.331 64.8188H1135.6V302.488H1200V107.599L1092.67 0ZM920.93 129.638V302.488H985.331V216.063H1070.77L1135.6 151.244H985.331V64.8188L920.93 129.638Z" />
  </svg>
)
